import React, { useState, useEffect } from 'react';
import { iAxios } from '../../lib/utils';
import Icon from '../ds/Icon';

const replaceEx = new RegExp('/rest.*', 'ig')

const getIssueLink = (i) => {
    return i.self.replace(replaceEx, `/browse/${i.key}`);
}


const createTestRun = (elements, issue, projectId, version, sprint, token) => {
    const ticketId = elements?.ticketId?.value;
    let data = null;
    let method = 'POST';
    let path = '/rest/api/2/issue';
    if (ticketId) {
        const transition = elements?.transition.value;
        const comment = elements?.comment.value;
        path = `/rest/api/2/issue/${ticketId}/transitions`;
        method = 'put';
        data = {
            fields: {
                customfield_10008: parseInt(sprint),
                fixVersions: [{ id: version }]
            },
            update: {
                comment: [
                    {
                        add: {
                            body: comment
                        }
                    }
                ]
            },
            transition: {
                id: parseInt(transition)
            }
        }
    } else {
        data = {
            fields: {
                project: {
                    key: projectId
                },
                summary: `[TestRun] - ${issue.fields.summary.trim()}`,
                description: issue.fields.description,
                issuetype: {
                    name: 'TestCaseRun'
                },
                fixVersions: [{
                    id: version
                }],
                labels: issue.fields.labels,
                timetracking: {
                    originalEstimate: '2m',
                    remainingEstimate: '2m'
                },
                components: issue.fields.components,
                assignee: issue.fields.assignee,
                customfield_10008: parseInt(sprint),
                customfield_10035: issue.fields.customfield_10035
            },
            update: {
                issuelinks: [
                    {
                        add: {
                            type: {
                                name: "Relates",
                                inward: "relates to",
                                outward: "relates to"
                            },
                            outwardIssue: {
                                key: issue.key
                            }
                        }
                    }
                ]
            }
        };
    }
    return iAxios.post('/api/v1/jira', {
        method,
        path,
        data,
        token
    }).then(resp => {
        if (resp.data.errorMessages) {
            alert(resp.data.errorMessages.join(','))
            return;
        }
    }).catch(ex => {
        alert(ex.message);
    });
}

export const JiraIssueItem = ({ item, idx, projectId, version, setNextCreateId, token, createId, sprint, components, startId }) => {
    const [issue, setIssue] = useState(item);
    const [status, setStatus] = useState(false);
    const [transitions, setTransitions] = useState([]);
    const [mode, setMode] = useState('');

    const runs = issue.fields.issuelinks.filter(item => item.outwardIssue)
        .map(item => item.outwardIssue)
        .filter(item => item.fields.issuetype?.name === 'TestCaseRun');

    if (runs.length === 0 && issue.fields.issuetype.name === 'TestCaseRun') {
        runs.push(issue);
    }
    useEffect(() => {
        if (!status || !run) {
            return;
        }
        iAxios.get('/api/v1/jira', {
            params: {
                path: `/rest/api/3/issue/${issue.key}/transitions`
            }
        }).then(resp => {
            setTransitions(resp.data.transitions);
        })
    }, [issue, status]);
    useEffect(() => {
        if (status == false) {
            return;
        }
        if (issue.fields.issuetype.name !== 'TestCaseRun') {
            return;
        }
        const inward = issue.fields.issuelinks.find(item => item.inwardIssue); 
        if (inward){
            fetchIssue(inward.inwardIssue.key);
        }
        // fetchIssue(issue.fields.issuelinks[0].inwardIssue.key)
    }, [status])

    const createRun = (e) => {
        e.preventDefault();
        const elements = e.target.elements;
        setMode('in-flight');
        createTestRun(elements, issue, projectId, version, sprint.id, token)
            .then(() => {
                fetchIssue();
            })
    }


    useEffect(() => {

        if (issue.key !== createId) {
            return;
        }

        if (mode === 'in-flight') {
            return;
        }

        const pendingRuns = runs.filter(r => r.fields.status.statusCategory.key !== 'done');
        if (pendingRuns.length > 0) { 
            setNextCreateId(createId);
            return;
        }
 
        // setNextCreateId();
        // setTimeout(() => { setNextCreateId(createId) }, 5000);
        // return;

        setMode('in-flight');
        createTestRun({}, issue, projectId, version, sprint.id, token)
            .then(() => {
                fetchIssue();
                setNextCreateId(createId);
            })
    }, [createId]);

    const fetchIssue = (key = '') => {
        let issueKey = key === '' ? issue.key : key;
        setMode('in-flight');
        return iAxios.get(`/api/v1/jira`, {
            params: {
                path: `/rest/api/3/issue/${issueKey}?expand=renderedFields`
            }
        }).then(resp => {
            setMode('');
            setIssue(resp.data);
        });
    }

    const updateTicket = (e) => {
        e.preventDefault();
        const elements = e.target.elements;
        const component = elements?.component.value;

        const path = `/rest/api/2/issue/${issue.key}`;
        const method = 'PUT';
        setMode('updating');
        const data = {
            fields: {
                components: [{ id: component }],
            }
        };
        iAxios.post('/api/v1/jira', {
            path,
            method,
            data,
            token
        }).then(resp => {
            setMode('');
            return fetchIssue();
        }).catch(ex => {

            setMode('');
            alert(ex.message);
        });
    }

    const runsView = runs.map(run => {
        const name = run.fields.status.name;
        let color = 'var(--ds-accent)';
        if (name === 'Rejected') color = 'var(--ds-danger)';
        else if (name === 'Accepted') color = 'var(--ds-success)';
        else if (name === 'Invalid') color = 'var(--ds-warning)';
        else if (run.id < startId) color = 'var(--ds-danger)';
        return <a key={run.key} target="_blank" rel="noreferrer"
            href={getIssueLink(run)} title={`[${name}] ${run.key} - ${run.fields.summary}`}
            style={{ display: 'inline-flex', padding: '2px' }}>
            <span style={{ width: '11px', height: '11px', borderRadius: '50%', background: color, display: 'inline-block' }} />
        </a>;
    }).reverse();
    const run = null;
    const pendingRuns = runs.filter(r => r.fields.status.statusCategory.key !== 'done');
    const dislableRun = !sprint || sprint.state === 'closed' || token === '' || version === "" || mode === 'in-flight' || pendingRuns.length > 0;

    return <div className="ds-card" style={{ marginBottom: 'var(--ds-space-3)' }}>
        <div style={{ display: 'flex', gap: 'var(--ds-space-3)', alignItems: 'flex-start', flexWrap: 'wrap' }}>
            <div style={{ flex: '1 1 320px', minWidth: 0 }}>
                <span className="ds-nums" style={{ color: 'var(--ds-ink-muted)' }}>{idx + 1}.</span>{' '}
                <b>{issue.key}</b> — <a target="_blank" rel="noreferrer" href={getIssueLink(issue)}>{issue.fields.summary}</a>
                <div className="issue-tags">
                    {issue.fields.components.map(item => <span key={item.name} className="issue-tag is-project">{item.name}</span>)}
                </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>{runsView}</div>
            <div style={{ textAlign: 'right' }}>
                <div style={{ fontSize: 'var(--ds-text-sm)' }}>{issue.fields?.assignee?.displayName}</div>
                <div style={{ fontSize: 'var(--ds-text-xs)', color: 'var(--ds-ink-faint)' }}>by {issue.fields.creator.displayName}</div>
                <button className="ds-btn is-ghost is-icon is-sm" style={{ marginTop: '4px' }} aria-expanded={status} aria-label="Toggle details" onClick={() => setStatus(!status)}>
                    <Icon name="chevronDown" style={{ transform: status ? 'rotate(180deg)' : 'none' }} />
                </button>
            </div>
        </div>

        {status && <div style={{ marginTop: 'var(--ds-space-4)' }}>
            <div className="cgs-markdown" dangerouslySetInnerHTML={{ __html: issue.renderedFields.description }} />

            {issue.fields.components.length === 0 && <form onSubmit={updateTicket} className="ds-field-row" style={{ marginTop: 'var(--ds-space-4)' }}>
                <label className="ds-field">
                    <span className="ds-label">Component</span>
                    <select name="component" className="ds-select">
                        {components.map(item => <option key={item.id} value={item.id}>{item.name}</option>)}
                    </select>
                </label>
                <button disabled={mode !== ''} className="ds-btn is-primary">
                    {mode === '' ? 'Update' : 'Saving…'}</button>
            </form>}

            <form onSubmit={createRun} style={{ marginTop: 'var(--ds-space-4)' }}>
                {run && <textarea className="ds-input" name="comment" style={{ height: '60px', padding: 'var(--ds-space-2)', marginBottom: 'var(--ds-space-3)' }} />}
                {dislableRun && <div style={{ fontSize: 'var(--ds-text-sm)', marginBottom: 'var(--ds-space-3)' }}>
                    {pendingRuns.length === 0 && <span style={{ color: 'var(--ds-danger)' }}>Select sprint, version and set your token to create runs</span>}
                    {pendingRuns.length > 0 && <div style={{ color: 'var(--ds-warning)' }}>Pending runs (set sprint and version):
                        {pendingRuns.map(i => <a key={i.key} target="_blank" rel="noreferrer" style={{ display: 'block' }} href={getIssueLink(i)}>{i.key}</a>)}
                    </div>}
                </div>}
                {run && <div style={{ marginBottom: 'var(--ds-space-3)' }}>
                    <input type="hidden" name="ticketId" value={run.key} />
                    <div><a href={getIssueLink(run)}>{run.key} — {run.fields.status.name}</a></div>
                    <select name="transition" className="ds-select" style={{ marginTop: 'var(--ds-space-2)' }}>
                        {transitions.map(item => <option key={item.id} value={item.id}>{item.name}</option>)}
                    </select>
                </div>}
                {(issue.fields.issuetype.name !== 'TestCaseRun' && run == null) && <div style={{ textAlign: 'right' }}>
                    <button disabled={dislableRun} className="ds-btn is-primary">Create run</button>
                </div>}
            </form>
        </div>}
    </div>;
}